import styled, { css } from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';
interface ContentWrapperProps {
  //
  hasAnnouncement: boolean;
  //
  hasDesktopTopbar: boolean;
  hasMobileTopbar: boolean;
  hasMobileTopbarSubNav: boolean;
}

export const ContentWrapper = styled('div')<ContentWrapperProps>`
  ${({ hasMobileTopbar, hasMobileTopbarSubNav, hasAnnouncement, theme }) => {
    //
    const announcementPadding = hasAnnouncement ? 28 : 0;
    //
    if (hasMobileTopbarSubNav) {
      const padding = announcementPadding + theme.x7spacePx + theme.x7spacePx;
      return `
        padding-top: calc(${padding}px + ${theme.safeAreaInsetTop});
      `;
    }
    if (hasMobileTopbar) {
      const padding = announcementPadding + theme.x8spacePx;
      return `
        padding-top: calc(${padding}px + ${theme.safeAreaInsetTop});
      `;
    }
  }};

  ${media.lgUp`
		${({ hasDesktopTopbar }) =>
      hasDesktopTopbar &&
      css`
        padding-top: ${({ theme }) => theme.x8spacePx}px;
      `}
	`};
`;

interface BodyProps {
  hasMobileFooterMenu: boolean;
}

export const Body = styled(Row)<BodyProps>`
  position: relative;
  z-index: 0;
  ${({ hasMobileFooterMenu, theme }) =>
    hasMobileFooterMenu &&
    media.mdDown`
      padding-bottom: calc(${theme.x8spacePx}px + ${theme.safeAreaInsetBottom});
    `};
`;
